import { createSlice } from '@reduxjs/toolkit';
import { getAnalytics } from 'api/clients/analytics';
import { dispatch } from '../index';

const initialState = {
    data: {},
    isLoading: false
};

const slice = createSlice({
    name: 'analytics',
    initialState,
    reducers: {
        setAnalytics(state, action) {
            state.data = action.payload;
            state.isLoading = false;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        }
    }
});

export default slice.reducer;

// fetch all clients list
export function fetchAnalytics() {
    return async () => {
        try {
            dispatch(slice.actions.setLoading(true));
            const analytics = await getAnalytics();
            dispatch(slice.actions.setAnalytics(analytics?.data));
        } catch (e) {
            throw new Error(e.message);
        } finally {
            dispatch(slice.actions.setLoading(false));
        }
    };
}
